module.exports = __webpack_public_path__ + "static/media/Wimpod_gaussian2.dab9af80.png";